export const useQuestionnaireUtils = () => {

    // الفانكشن دي بتحدد السؤال يظهر ولا يختفي بناءً على إجابة سؤال تاني
    const checkApplicability = (allQuestions, parentQuestionId, selectedAnswers) => {
        return allQuestions.map(item => {
            if (item.pirm_addon__Question__r.pirm_addon__Related_Question__c === parentQuestionId) {
                const relatedAnswers = JSON.parse(item.pirm_addon__Question__r.pirm_addon__Related_Answers__c || "[]");
                const isMatch = selectedAnswers.some(ans => relatedAnswers.includes(ans));
                return { ...item, pirm_addon__IsApplicable__c: isMatch };
            }
            return item;
        });
    };

    const calculateProgress = (questions) => {
        const applicable = questions?.filter(q => q.pirm_addon__IsApplicable__c && q.pirm_addon__QuestionType__c !== "Blocker") || [];
        const answered = applicable.filter(q => q.pirm_addon__Answer__c || q.ContentDocumentLinks).length;
        const total = applicable.length;
        return {
            answered,
            total,
            percentage: total > 0 ? (answered / total) * 100 : 0
        };
    };

    return { calculateProgress, checkApplicability };
};